import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import scrollToElement from "helpers/scroll-to-element"
import useWindowDimensions from "helpers/window-dimensions"

const H1 = (props) => (
  <h1
    className="tablet:mb-32 text-30 mb-16 font-bold leading-none"
    {...props}
  />
)

const H2 = (props) => (
  <h2 className="text-20 mb-16 font-semibold leading-none" {...props} />
)

const H3 = (props) => (
  <h3 className="text-18 leading-20 mb-16 font-semibold" {...props} />
)

const H4 = (props) => (
  <h4 className="text-16 leading-18 mb-16 font-semibold" {...props} />
)

const P = (props) => (
  <p className="text-16 leading-22 my-16 font-light" {...props} />
)

const Li = (props) => (
  <li className="text-16 leading-22 font-light" {...props} />
)

const Strong = (props) => <strong className="font-bold" {...props} />

const A = ({ href, ...props }) => {
  const Comp = href ? "a" : Link

  return (
    <Button
      asChild
      className="inline whitespace-normal font-medium"
      text
      underline
      variant="secondary"
    >
      <Comp href={href} {...props} />
    </Button>
  )
}

A.propTypes = {
  href: PropTypes.string,
}

const AnchorLink = ({ href, ...props }) => {
  const { isLarge } = useWindowDimensions()

  return (
    <A
      href={href}
      onClick={(e) => {
        e.preventDefault()
        scrollToElement(href, isLarge ? 210 : 160)
      }}
      {...props}
    />
  )
}

AnchorLink.propTypes = {
  href: PropTypes.string,
}

const Table = (props) => (
  <div className="max-w-full overflow-x-auto">
    <table
      className="widescreen:m-60 desktop:table-fixed desktop:w-full w-max min-w-full table-auto"
      {...props}
    />
  </div>
)

const Tr = (props) => <tr className="border-b border-b-black" {...props} />

const Th = (props) => (
  <th
    className="h3 desktop:px-20 px-12 py-20 text-left font-semibold uppercase"
    {...props}
  />
)

const Td = (props) => (
  <td
    className="body desktop:px-20 max-w-[24rem] whitespace-normal break-words px-12 py-20"
    {...props}
  />
)

export const components = {
  a: ({ href, ...props }) =>
    href?.startsWith("http") ? (
      <A href={href} target="_blank" {...props} />
    ) : href?.startsWith("#") ? (
      <AnchorLink href={href} {...props} />
    ) : (
      <A target="_blank" to={href} {...props} />
    ),
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  li: Li,
  p: P,
  strong: Strong,
  table: Table,
  td: Td,
  th: Th,
  tr: Tr,
}
